export const parseNumericValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value !== "string") {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const lastComma = trimmed.lastIndexOf(",");
  const lastDot = trimmed.lastIndexOf(".");
  let normalized = trimmed;

  if (lastComma > -1 && lastDot > -1) {
    normalized = lastComma > lastDot
      ? trimmed.replace(/\./g, "").replace(",", ".")
      : trimmed.replace(/,/g, "");
  } else if (lastComma > -1) {
    normalized = trimmed.replace(/\./g, "").replace(",", ".");
  }

  const numeric = Number(normalized);

  return Number.isFinite(numeric) ? numeric : null;
};

const makeOptions = ({ minimumFractionDigits = 0, maximumFractionDigits = 2 } = {}) => ({
  minimumFractionDigits,
  maximumFractionDigits,
  useGrouping: true,
});

export const formatNumber = (value, options) => {
  const numeric = parseNumericValue(value);

  if (numeric === null) {
    return value === null || value === undefined || value === "" ? "-" : value;
  }

  return new Intl.NumberFormat("es-AR", makeOptions(options)).format(numeric);
};

export const formatInteger = (value) => (
  formatNumber(value, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
);

export const formatDecimal = (value, fractionDigits = 2) => (
  formatNumber(value, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
);

export const formatDecimalOrZero = (value, fractionDigits = 2) => (
  formatDecimal(parseNumericValue(value) ?? 0, fractionDigits)
);
